import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from './main.component';
import { AuthLayoutComponent} from './auth.component';

/*Guard Auth*/
import { AuthGuard }    from '../_services/auth.guard';

const routes: Routes = [
  {
    path: 'auth', component: AuthLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('../auth/auth.module').then(m => m.AuthModule) },
    ]
  },
  {
    path: '', component: MainLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('../main/main.module').then(m => m.MainModule) },
      { path: 'elearning', loadChildren: () => import('../elearning/elearning.module').then(m => m.ElearningModule) },
      { path: '', loadChildren: () => import('../profile/profile.module').then(m => m.ProfileModule) },
      { path: 'error', loadChildren: () => import('../errors/errors.module').then(m => m.ErrorModule) },
      { path: '**', redirectTo: '/error/404', pathMatch: 'full'}
    ],
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule { }
